import React from 'react';
import { IconButton } from '@mui/material';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import EditIcon from '@mui/icons-material/Edit';
import { Athlete } from '../../components/dialogs/edit-athlete.dialog';

export const MANAGE_ATHLETES_COLUMNS = (actions: any[]) => [
  {
    field: 'id',
    headerName: 'ID',
  },
  {
    field: 'name',
    headerName: 'Name',
    width: 250,
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 250,
  },
  {
    field: 'role',
    headerName: 'Role',
  },
  {
    field: 'edit',
    headerName: 'Edit',
    sortable: false,
    renderCell: (params: any) => {
      return (
        <IconButton onClick={() => actions[0](params.row as Athlete)}>
          <EditIcon color="primary" />
        </IconButton>
      );
    },
  },
  {
    field: 'action',
    headerName: 'Remove',
    sortable: false,
    renderCell: (params: any) => {
      return (
        <IconButton onClick={() => actions[1](params.id)}>
          <PersonRemoveIcon color="error" />
        </IconButton>
      );
    },
  },
];

export const TEAM_DETAILS_TABS = (teamId: string, isCoach: boolean) => {
  const tabs = [{ label: 'Dashboard', value: `/teams/${teamId}/dashboard` }];

  if (isCoach) {
    tabs.push({ label: 'Team Training Plan', value: `/teams/${teamId}/team-trainings` });
    tabs.push({
      label: 'Athlete Schedules & Training Logs',
      value: `/teams/${teamId}/athlete-schedules`,
    });
  }
  tabs.push(
    { label: 'Messages', value: `/teams/${teamId}/messages` },
    { label: 'Team Roster', value: `/teams/${teamId}/roster` }
  );

  if (isCoach) {
    tabs.push({ label: 'Equipment', value: `/teams/${teamId}/equipment` });
  }

  tabs.push({ label: 'Race Log', value: `/teams/${teamId}/race-log` });

  return tabs;
};
